import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';

function ClosingSummaryNew() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [orderdate, setOrderdate] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [saleOrderId, setSaleOrderId] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [filteredData, setFilteredData] = useState([]);
    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [TripName, settripName] = useState("");
    const [Startkm, setStartkm] = useState("");
    const [EndKm, setEndKm] = useState("");
    const [DriverName, setDriverName] = useState("");
    const [vehicleNo, setvehicleNo] = useState("");
    const [route, setroute] = useState("");

    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]);

        try {
            const response = await fetchData('CollectionSummaryByRouteApi', `/newdetails/${companyId}/${selectedOption.value}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                dataArray.forEach(item => { });
                setData(dataArray);
                if (dataArray.length > 0) {
                    setSaleOrderId(dataArray[0].id);
                    setCorderdate(dataArray[0].orderDate);
                    setOrdertakenby(dataArray[0].orderTakenby);
                    setroute(dataArray[0].routeName);
                    settripName(dataArray[0].tripName);
                    setStartkm(dataArray[0].StartKm);
                    setEndKm(dataArray[0].EndKm);
                    setDriverName(dataArray[0].DriverName);
                    setvehicleNo(dataArray[0].VehicleNo);
                } else {
                    console.error('Unexpected response code:', response.responseCode);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };



    const handleHistoryClick = async (saleorderid) => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}/${saleorderid}`, token);
            if (response.responseCode === '1111') {
                setSelectedCustomerData(response.response_data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Route Closing Summary</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Route Closing Summary</h3>');
        if (data.length > 0) {
            const firstRow = data[0]; // Use the first row for common details
            printWindow.document.write('<div style="margin-bottom: 20px;">');
            printWindow.document.write(`<p style="font-size: 18px;">`);
            printWindow.document.write(`<strong>Route:</strong> ${firstRow.routeName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Taken by:</strong> ${firstRow.orderTakenby || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Sales Executive:</strong> ${firstRow.salesman || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Date:</strong> ${firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Vehicle No.:</strong> ${firstRow.VehicleNo || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Driver :</strong> ${firstRow.DriverName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Trip Date:</strong> ${firstRow.tripName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Start KM:</strong> ${firstRow.StartKm || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>End KM:</strong> ${firstRow.EndKm || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`</p>`);
            printWindow.document.write('</div>');
        }

        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Customer</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Product Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item </th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">UOM (Kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Quantity</th>');

        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">PaymentReceivedBy</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">PaymentMode</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Paid Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Outstanding Amount</th>');

        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${index + 1}</td>`);

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerName}</td>`);
            // Check if orderDate is null or undefined, and display an empty cell if so
            if (rowData.orderDate) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${new Date(rowData.orderDate).toLocaleDateString('en-GB')}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.orderDate && new Date(rowData.orderDate).toLocaleDateString('en-GB')}</td>`);

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.productCategory}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.itemCode}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.kilogram}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${rowData.quantity}</td>`);

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${rowData.paymentReceivedBy}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${rowData.paymentMode}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${rowData.totalAmount.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${rowData.paidamount.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${rowData.outstanding.toFixed(2)}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];

        // Add a header section for common details (Route, Order Taken by, etc.)
        if (data.length > 0) {
            const firstRow = data[0]; // Assuming first row holds common details

            // Create a separate row for these common fields
            excelData.push([
                'Route:', firstRow.routeName || '',
                'Order Taken by:', firstRow.orderTakenby || '',
                'Sales Executive:', firstRow.salesman || '',
                'Order Date:', firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : '',
                'Trip Name:', firstRow.tripName || '',
                'Vehicle No.:', firstRow.VehicleNo || '',
                'Driver:', firstRow.DriverName || '',
                'Start Km:', firstRow.StartKm || '',
                'End Km:', firstRow.EndKm || ''
            ]);

            // Empty row for spacing
            excelData.push([]);
        }

        // Add column headers for customer-specific data
        const headerRow = [
            'Sl.No',
            'Customer',
            'Product Category',
            'Item Code',
            'Item',
            'UOM (Kgs)',
            'Quantity',
            'Payment Received By',
            'Payment Mode',
            'Total Amount',
            'Paid Amount',
            'Outstanding Amount'
        ];
        excelData.push(headerRow);

        // Add customer-specific data rows
        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,                               // Sl.No
                rowData.CustomerName || '',              // Customer
                rowData.productCategory || '',           // Product Category
                rowData.itemCode || '',                  // Item Code
                rowData.item || '',                      // Item
                rowData.kilogram || '',                  // UOM (Kgs)
                rowData.quantity || '',                  // Quantity
                rowData.paymentReceivedBy || '',         // Payment Received By
                rowData.paymentMode || '',               // Payment Mode
                rowData.totalAmount ? rowData.totalAmount.toFixed(2) : '', // Total Amount
                rowData.paidamount ? rowData.paidamount.toFixed(2) : '',   // Paid Amount
                rowData.outstanding ? rowData.outstanding.toFixed(2) : ''  // Outstanding Amount
            ];
            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Route Closing Summary');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Route Closing Summary.xlsx');
    };


    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };
    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder', marginTop: '10px', fontSize: '17px' }}>CLOSING SUMMARY DETAILS </h6>
            <div className="flex mb-2" style={{ marginTop: '-20px', marginLeft: '20%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken Date: <strong style={{ color: 'darkred' }}>{Corderdate && new Date(Corderdate).toLocaleDateString('en-GB')}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken By: <strong style={{ color: 'darkmagenta' }}>{orderTakenby}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Trip Name: <strong style={{ color: 'darkgreen' }}>{TripName}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Driver Name: <strong style={{ color: 'darkorange' }}>{DriverName}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Vehicle No.: <strong style={{ color: 'darkviolet' }}>{vehicleNo}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Start Km: <strong style={{ color: 'brown' }}>{Startkm}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    End Km: <strong style={{ color: 'purple' }}>{EndKm}</strong>
                </h5>
            </div>

            <div className="flex justify-end">
                <Button onClick={handleExportExcel} style={{ background: '#08396B', color: 'whitesmoke', fontWeight: 'bolder', height: '25px' }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Excel"}
                </Button>
                <Button onClick={handlePrint} style={{ background: 'darkmagenta', color: 'whitesmoke', fontWeight: 'bolder', height: '25px', marginLeft: '2px' }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Print"}
                </Button>
                <Button onClick={handleRefreshClick} style={{ background: '#dc3545', color: 'whitesmoke', fontWeight: 'bolder', height: '25px', marginLeft: '2px' }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Refresh"}
                </Button>

                <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                    />
                </div>
            </div>
            <div className='w-full mb-5 flex' style={{ overflowY: 'auto', Width: '2500px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Bill No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Receipt No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Customer</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Salesman</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>ReceivedBy</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>PaymentMode</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '50px' }}>Total Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '50px' }}>Paid Amount</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '70px' }}>Advance Amount</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '40px' }}>OutStanding</TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '#E4E0E1' }}>

                            {data.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.routeName === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '3px',
                                        height: '32px',

                                        backgroundColor: item.routeName === 'Total' ? 'teal' : 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{item.InvoiceNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{item.ReceiptNo}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '150px' }}>{item.CustomerName}</TableCell> */}
                                    <a href="#" onClick={() => handleHistoryClick(item.SaleOrderId)} className="tooltip-link">
                                        <h6 style={{ fontFamily: 'Times New Roman', color: 'black', cursor: 'pointer' }}>{item.CustomerName}</h6>
                                    </a>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{item.salesman}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{item.paymentReceivedBy}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>{item.paymentMode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>{item.totalAmount != null ? item.totalAmount.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>{item.paidamount != null ? item.paidamount.toFixed(2) : ''}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>{item.advanceAmount != null ? item.advanceAmount.toFixed(2) : ''}</TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>{item.outstanding != null ? item.outstanding.toFixed(2) : ''}</TableCell>


                                </TableRow>
                            ))}
                        </TableBody>


                    </Table>
                </TableContainer>
            </div>

            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1200px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h6 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: '#347928', fontWeight: 'bolder' }}>ORDERED ITEMS</h6>
                        <div className="used-items-container">
                            <TableContainer component={Paper} style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                                <table className="table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Sl.No</th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Name</th>
                                            <th style={{ width: '7%', fontSize: '14px' }}>Qty(No.Pieces)</th>
                                            <th style={{ width: '7%', fontSize: '14px' }}>T.Qty
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Kgs)</p>
                                            </th>
                                            <th style={{ width: '12%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Per Kg)</p>
                                            </th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>Discount
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Per Item)</p>
                                            </th>
                                            <th style={{ width: '12%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(After Discount)</p>
                                            </th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Taxable <span style={{ fontSize: '12px' }}>Amt</span></th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>GST <span style={{ fontSize: '12px' }}>Amt</span></th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Total <span style={{ fontSize: '12px' }}>Amt</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{index + 1}</td>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{item.item}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.quantity || 0}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.totalQty || 0}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.ratePerKg ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.discount ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.rateAfterDiscount ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.taxableAmt ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {((item.sgstAmt ?? 0) + (item.cgstAmt ?? 0)).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.netAmt ?? 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}
                                        {selectedCustomerData && selectedCustomerData.length > 0 && (
                                            <tr>
                                                <td className="px-4 py-2 border-r" colSpan="2" style={{ fontSize: '12px', fontWeight: 'bold' }}>Total</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.quantity || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.totalQty || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.ratePerKg || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.discount || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.rateAfterDiscount || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.taxableAmt || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + ((item.sgstAmt || 0) + (item.cgstAmt || 0)), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.netAmt || 0), 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </TableContainer>



                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    );
}

export default ClosingSummaryNew;

